import * as styles from "../../../../styles/DefaultSetting";
import React, { useCallback, useEffect, useLayoutEffect, useState, useRef } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import userSlice from "../../../../reducer/user";
import { useAppDispatch } from "../../../../store";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { Farmstype } from "reduxaction/posttypes";

interface mainitemType {
  containerId: string;
  boxName: string;
  productCode: string;
  startFarmDate: string;
}

dayjs.locale("ko");
const BoxAddAll = () => {
  const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const [targetFarmInfo, setTargetFarmInfo] = useState<Farmstype>(); // 타겟팜 정보

  let [totaldata, setTotaldata] = useState<any>(); // 전체 데이터
  let [containerId, setContainerId] = useState<number>(); // 초기 containerId값
  let [container, setContainer] = useState(); // 사육실
  let [insect, setInsect] = useState<any>(); // 곤충 선택 값
  let [defaultInsect, setDefaultInsect] = useState<any>(); // 초기 곤충 값

  const [beforeBoxes, setBeforeBoxes] = useState<string[]>([]);

  const [mainitem, setMainitem] = useState<mainitemType>({
    containerId: "",
    boxName: "",
    productCode: "",
    startFarmDate: "",
  });
  const [items, setItems] = useState<any[]>([
    {
      containerId: "",
      boxName: "",
      productCode: "",
      startFarmDate: "",
    },
  ]);
	

  useEffect(() => {
    const getBeforeBoxes = async () => {
      const beforBoxes = await axios.get(
        `ifactory/api/managebox/reuse`
      );
      beforBoxes.data.unshift("선택해주세요");
      setBeforeBoxes(beforBoxes.data);
    };

    getBeforeBoxes();
  }, []);

  const handleAdd = () => {
    let emptyItem = {
      containerId: containerId,
      boxName: "",
      productCode: insect?.[0].productCode,
      startFarmDate: "",
    };
    setItems([...items, emptyItem]);
  };

  const handleRemove = () => {
    if (items.length > 1) {
      let newItems = [...items];
      newItems.pop();
      setItems(newItems);
    }
  };

	// targetFarmInfo 세팅
	useEffect(() => {
		const farmInfo = localStorage.getItem("targetfarmInfo");
		setTargetFarmInfo(farmInfo && JSON.parse(farmInfo));
	}, []);


	useEffect(() => {		
		if (!targetFarmInfo) return;
		
		const settingContainer = async () => {
			try {
				const response = await axios.get(`/ifactory/api/place/specificplace?id=${targetFarmInfo?.placeId}&type=${targetFarmInfo?.type}`);
				setTotaldata(response.data);
				setContainerId(response.data[0].containerId);	
			} catch (error:any) {
				confirmAlert({
					title: error.response.data,
					buttons: [{ label: "Yes" }],
				});
			}
		}

		const settingInsect = async () => {
			try {
				const response = await axios.get(`/ifactory/api/productcode`);
				setDefaultInsect(response.data[0].productCode);
				setInsect(response.data);					
			} catch (error:any) {
				confirmAlert({
					title: error.response.data,
					buttons: [{ label: "Yes" }],
				});
			}
		}
		
		settingContainer();
		settingInsect();
  }, [targetFarmInfo]);

  useEffect(() => {
    setItems([
      {
        containerId: totaldata?.[0]?.containerId,
        boxName: "",
        productCode: insect?.[0].productCode,
        startFarmDate: "",
      },
    ]);

    setMainitem({
      containerId: totaldata?.[0]?.containerId,
      boxName: "",
      productCode: insect?.[0].productCode,
      startFarmDate: "",
    });

    // setItems(items[0].containerId = totaldata?.[0]?.containerId);
  }, [totaldata, insect]);

  const mainhandleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setMainitem((prevMainitem) => ({ ...prevMainitem, [name]: value }));

    if (name !== "boxName") {
      setItems((prevItems) => {
        const updatedItems = prevItems.map((item) => {
          if (item.containerId === mainitem.containerId) {
            return { ...item, [name]: value };
          }
          return item;
        });

        return updatedItems;
      });
    }
  };

  //입력 데이터 컨트롤러
  const handleChange = (e: any) => {
    const hasBoxname = items.find(
      (v: mainitemType) => v.boxName === e.target.value
    );

    if (hasBoxname) {
      return confirmAlert({
        title: "중복된 RFID코드가 있습니다.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }

    let newItems = [...items];
    let index = e.target.dataset.index;
    let stateKey = e.target.dataset.statekey;

    newItems[index] = {
      ...newItems[index],
      [stateKey]: e.target.value,
    };
    setItems([...newItems]);
  };

  const PostSubmit = () => {
    axios
      .post(`ifactory/api/managebox`, items)
      .then((res) => {
        console.log("res", res);
        confirmAlert({
          title: "사육 상자 등록이 완료되었습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
        navigate("/Boxmanagement");
      })
      .catch((error) => {
        confirmAlert({
          title: error.response.data.message,
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      });
  };

  return (
    <styles.Container style={{ background: "#fff" }}>
      <styles.PageTop>
        <p className="move-btn">
          <img src="./img/ArrowLeft.svg" alt="좌향버튼" onClick={() => { navigate("/Boxmanagement"); }} />
        </p>
        <p className="pagetit">기본설정</p>
        <button className="post-submit" onClick={() => { PostSubmit(); }}>작성</button>
      </styles.PageTop>
      <styles.PageTitle className="noneborder">
        <div className="title">
          <img src="./img/MiniBox.svg" alt="상자이미지" />
          <p>상자 관리</p>
        </div>
      </styles.PageTitle>

      <styles.AddBoxItemList>
        <div className="Itemlist">
          <p>사육실</p>
          <select name="containerId" onChange={(e) => mainhandleChange(e)}>
            {totaldata &&
              totaldata.map((container: any, idx: number) => <option value={container.containerId} key={ idx }>{container.containerName}</option>)}
          </select>
        </div>
        <div className="Itemlist">
          <p>RFID코드</p>

          <input
            type="text"
            name="boxName"
            onChange={(e) => mainhandleChange(e)}
            placeholder="RFID코드는 개별적으로 등록해주세요."
            value={""}
          />
        </div>
        <div className="Itemlist">
          <p>사육 곤충</p>
          <select name="productCode" onChange={(e) => mainhandleChange(e)}>
            {insect &&
              insect.map((insect: any, idx: number) => <option value={insect.productCode} key={ idx }>{insect.productName}</option>)}
          </select>
        </div>
        <div className="Itemlist">
          <p>사육 시작일</p>
          <input
            type="date"
            name="startFarmDate"
            onChange={mainhandleChange}
            // data-index={index}
          />
        </div>
      </styles.AddBoxItemList>
      {/* ------------------------------------------------------------------------------------------------------------ */}
      <styles.ButtonBox style={{ marginBottom: 10 }}>
        <button className="remove" onClick={() => { handleRemove(); }} >
          <p className="radius">-</p>
          <p className="text">삭제</p>
        </button>
        <button className="add" onClick={() => { handleAdd(); }} >
          <p className="radius add">+</p>
          <p className="text">추가</p>
        </button>
      </styles.ButtonBox>


      <styles.AddBoxItemContainer>
        {items &&
          items.map((item: mainitemType, index: number) => {
            return (
              <styles.AddBoxItemList key={ index }>
                <div className="Itemlist">
                  <p>사육실</p>
                  <select
										name="container"
										onChange={handleChange}
										data-statekey="containerId"
										data-index={index}
										value={item.containerId}
                  >
                    {totaldata &&
											totaldata.map((totaldata: any, idx: number) => <option value={totaldata.containerId} key={idx}>{totaldata.containerName}</option>)
										}
                  </select>
                </div>
                <div className="Itemlist">
                  <p>RFID코드</p>
                  <select
                    name="boxName"
                    onChange={handleChange}
                    data-statekey="boxName"
                    data-index={index}
                    value={item.boxName}
                  >
                    {beforeBoxes &&
                      beforeBoxes.map((boxName: any, idx: number) => {
												return <option value={boxName} key={ idx }>{boxName}</option>;
                      })}
                  </select>
                </div>
                <div className="Itemlist">
                  <p>사육 곤충</p>
                  <select
                    name="insect"
                    onChange={handleChange}
                    data-statekey="productCode"
                    data-index={index}
                    value={item.productCode}
                  >
                    {insect &&
                      insect.map((insect: any, idx: number) => {
												return <option value={insect.productCode} key={idx}>{insect.productName}</option>;
                      })}
                  </select>
                </div>
                <div className="Itemlist">
                  <p>사육 시작일</p>
                  <input
                    type="date"
                    name="startday"
                    onChange={handleChange}
                    data-statekey="startFarmDate"
                    data-index={index}
                    value={item.startFarmDate}
                  />
                </div>
              </styles.AddBoxItemList>
            );
          })}
      </styles.AddBoxItemContainer>
    </styles.Container>
		
  );
};

export default BoxAddAll;
